import {
  SIGNUP_SET_ACCOUNT_HOLDER,
  SIGNUP_SET_ACTIVE_SIGNUP,
  SIGNUP_SET_ACTIVE_SIGNUP_STATUS,
  SIGNUP_SET_BILLING_HOLDER,
  SIGNUP_SET_QUESTIONNAIRE_VALUES,
  SIGNUP_SET_ADDON_VALUES,
  SIGNUP_RESET_LOCATION,
  SIGNUP_RESET_SIGNUP,
  SIGNUP_SET_AVAIL_PLANS,
  SIGNUP_SET_LOCATION,
  SIGNUP_SET_LOCATION_MARKER,
  SIGNUP_SET_SELECTED_PLAN,
  SIGNUP_SET_FORM_STEP,
  SIGNUP_SET_CHECKING_STATUS, SIGNUP_RESET_ACTIVE_SIGNUP,
} from './mutations.types'
import {
  _PROCESS_ERROR, SIGNUP_GET_PLANS_AVAIL,
  SIGNUP_CHECK_STATUS,
  SIGNUP_SUBMIT_EZ_SIGNUP,
  SIGNUP_CONFIRM_SIGNUP, _COMMIT_LOG,
} from './actions.types'
import PublicService from '../services/public.service'
import SignupService from '../services/signup.service'
import router from '../router'

const initialState = {
  optionsLocationTypes: [
    {
      text: 'Residential',
      value: 'residential',
    },
    {
      text: 'Commercial',
      value: 'commercial',
    },
    {
      text: 'Agriculture',
      value: 'agriculture',
    },
  ],
  optionsLocationFloors: [
    {
      text: 'Single Floor',
      value: 'single_floor',
    },
    {
      text: 'Multi floor',
      value: 'multi_floor',
    },
  ],
  optionsRoofMaterial: [
    {
      text: 'Tile',
      value: 'tile',
    },
    {
      text: 'Composition',
      value: 'composition',
    },
    {
      text: 'Other',
      value: 'other',
    },
  ],
  optionsSquareFootage: [
    {
      text: '1200 sq ft or less',
      value: 1200,
    },
    {
      text: '1500 sq ft',
      value: 1500,
    },
    {
      text: '1800 sq ft',
      value: 1800,
    },
    {
      text: '2000 sq ft',
      value: 2000,
    },
    {
      text: '2200 sq ft',
      value: 2200,
    },
    {
      text: '2400 sq ft',
      value: 2400,
    },
    {
      text: '2600+ sq ft',
      value: 2600,
    },
  ],
  optionsOwnershipStatus: [
    {
      text: 'Own',
      value: 'own',
    },
    {
      text: 'Rent or Lease',
      value: 'rent',
    },
  ],
  optionsInstallType: [
    {
      text: 'Standard',
      description: 'Exposed cable neatly routed through an exterior wall',
      value: 'standard',
      price: 45.00,
    },
    {
      text: 'Advanced',
      description: 'Cable ran to an interior wall from attic or crawl space',
      value: 'advanced',
      price: 145.00,
    },
  ],
  optionsPaymentFrequency: [
    {
      text: 'Monthly',
      description: '(No Discount)',
      value: 1,
    },
    {
      text: 'Prepay 6 Months',
      description: '(2.5% discount)',
      value: 6,
    },
    {
      text: 'Prepay 12 Months',
      description: '(5% discount)',
      value: 12,
    },
  ],
  optionsPaymentMethod: [
    {
      text: 'eCheck',
      description: 'Checking and routing number',
      value: 'echeck',
      price: 0,
    },
    {
      text: 'Bank bill pay',
      description: 'Setup bill pay via your bank',
      value: 'bankbillpay',
      price: 0,
    },
    {
      text: 'Credit Card',
      description: 'Visa/Mastercard only',
      value: 'creditcard',
      price: 0,
    },
  ],
  optionsEnrollNoWorries: [
    {
      text: 'Yes',
      value: 1,
    },
    {
      text: 'No',
      value: -1,
    },
  ],
  optionsAddonBridge: [
    {
      text: 'No',
      value: 'no',
    },
    {
      text: 'Yes - Purchase',
      description: '$500 one time fee',
      value: 'purchase',
    },
    {
      text: 'Yes - Rent',
      description: '$50 upfront and $10/mo recurring',
      value: 'rent',
    },
  ],
  optionsNetworkJacks: [
    {
      text: '0',
      value: 0,
      price: 0,
    },
    {
      text: '1',
      value: 1,
      price: 100,
    },
    {
      text: '2',
      value: 2,
      price: 200,
    },
    {
      text: '3',
      value: 3,
      price: 300,
    },
  ],
  optionsHeardAboutUs: [
    {
      text: '0',
      value: 0,
      price: 0,
    },
    {
      text: '1',
      value: 1,
      price: 100,
    },
    {
      text: '2',
      value: 2,
      price: 200,
    },
    {
      text: '3',
      value: 3,
      price: 300,
    },
  ],
  optionsPermissionToModify: [
    {
      text: 'Yes',
      value: 1,
    },
    {
      text: 'No',
      value: -1,
    },
  ],
  optionsConfirmMounting: [
    {
      text: 'Yes',
      value: 1,
    },
    {
      text: 'No',
      value: -1,
    },
  ],
  formStep: 1,
  questionnaireValues: {
    locationType: false,
    floorDetails: false,
    roofMaterial: false,
    squareFootage: 0,
    ownershipStatus: false,
    canModify: false,
    confirmMountEquipment: false,
  },
  addonValues: {
    installType: false,
    enrollNoWorries: 0,
    enrollWifiUpgrade: false,
    addNetworkJacks: false,
    addNetworkJacksQuantity: 0,
    addonBridge: null,
  },
  accountHolder: {
    first_name: '',
    last_name: '',
    mobile_phone: '',
    mobile_phone_code: '',
    mobile_phone_verified: false,
    alt_phone: '',
    email: '',
    is_email_unique: false,
    email_code: '',
    email_verified: false,
  },
  billingHolder: {
    first_name: '',
    last_name: '',
    mobile_phone: '',
    alt_phone: '',
    email: '',
  },
  location: {
    rowkey: '',
    formatted_address: '',
    street_number: '',
    route: '',
    city: '',
    state: '',
    postal_code: '',
    county: '',
    country: '',
    lat: '',
    lng: '',
  },
  locationMarker: {
    lat: 0,
    lng: 0,
  },
  selectedPlan: null,
  availablePlans: [],
  activeEzSignup: {
    id: '',
    rowkey: '',
    payload: {},
  },
  activeEzSignupStatus: '',
  isCheckingStatus: false,
}

export const state = { ...initialState }

export const actions = {
  async [SIGNUP_GET_PLANS_AVAIL] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Getting plans available: ', payload)
      const response = await PublicService.getAvailablePlans(payload)
      dispatch(_COMMIT_LOG, { message: 'GET avail plans response: ', data: response.data })
      commit(SIGNUP_SET_LOCATION, response.data.location)
      commit(SIGNUP_SET_AVAIL_PLANS, response.data.plans)
      return response.data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Create an ezSignup submission
   * @param {object} params.selectedPlan values from the selectedPlan section
   * @param {object} params.accountHolder values from the accountHolder section
   * @param {object} params.location values from the location section
   * @param {object} params.locationMarker values from the locationMarker section
   * @param {object} params.billingHolder values from the billingHolder section
   * @param {object} params.questionnaireValues values from the questionnaire section
   * @param {object} params.addonValues values from the addon section
   * @returns {*}
   */
  async [SIGNUP_SUBMIT_EZ_SIGNUP] ({ dispatch, commit, rootState }, params) {
    try {
      console.log('Submitting ez signup: ', params)
      const response = await SignupService.ezSignup({ form_data: params })
      console.log('EZ Signup response: ', response.data)
      commit(SIGNUP_SET_ACTIVE_SIGNUP, response.data)
      dispatch(SIGNUP_CHECK_STATUS, { rowkey: response.data.rowkey })
      return response.data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Get status of current active signup
   * @param {object} params.rowkey values from the selectedPlan section
   * @returns {*}
   */
  async [SIGNUP_CHECK_STATUS] ({ dispatch, commit, rootState }, params) {
    try {
      commit(SIGNUP_SET_CHECKING_STATUS, true)
      console.log('Checking ez signup: ', params)
      const response = await SignupService.checkStatus(params.rowkey)
      console.log('EZ Signup status: ', response.data)
      commit(SIGNUP_SET_CHECKING_STATUS, false)
      commit(SIGNUP_SET_ACTIVE_SIGNUP_STATUS, response.data.status)
      return response.data
    } catch (e) {
      commit(SIGNUP_SET_CHECKING_STATUS, false)
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Confirm an EZ signup form submission
   * @param {string} params.rowkey rowkey of the form to process
   * @returns {*}
   */
  async [SIGNUP_CONFIRM_SIGNUP] ({ dispatch, commit, rootState }, params) {
    try {
      commit(SIGNUP_SET_CHECKING_STATUS, true)
      console.log('Confirming ez signup: ', params)
      const response = await SignupService.confirm(params.rowkey)
      console.log('New Account: ', response.data)
      commit(SIGNUP_RESET_SIGNUP)
      router.push('/app')
      return response.data
    } catch (e) {
      commit(SIGNUP_SET_CHECKING_STATUS, false)
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
}

export const mutations = {
  [SIGNUP_SET_FORM_STEP] (state, data) {
    state.formStep = data
  },
  [SIGNUP_SET_ACCOUNT_HOLDER] (state, data) {
    state.accountHolder = data
  },
  [SIGNUP_SET_BILLING_HOLDER] (state, data) {
    state.billingHolder = data
  },
  [SIGNUP_SET_QUESTIONNAIRE_VALUES] (state, data) {
    state.questionareValues = data
  },
  [SIGNUP_SET_ADDON_VALUES] (state, data) {
    state.addonValues = data
  },
  [SIGNUP_SET_LOCATION] (state, data) {
    state.location = data
  },
  [SIGNUP_SET_LOCATION_MARKER] (state, data) {
    state.locationMarker = data
  },
  [SIGNUP_SET_SELECTED_PLAN] (state, data) {
    state.selectedPlan = data
  },
  [SIGNUP_SET_AVAIL_PLANS] (state, data) {
    state.availablePlans = data
  },
  [SIGNUP_SET_ACTIVE_SIGNUP] (state, data) {
    state.activeEzSignup = data
  },
  [SIGNUP_SET_ACTIVE_SIGNUP_STATUS] (state, data) {
    state.activeEzSignupStatus = data
  },
  [SIGNUP_SET_CHECKING_STATUS] (state, data) {
    state.isCheckingStatus = data
  },
  [SIGNUP_RESET_LOCATION] (state) {
    state.location = initialState.location
    state.locationMarker = initialState.locationMarker
    state.availablePlans = initialState.availablePlans
  },
  [SIGNUP_RESET_ACTIVE_SIGNUP] (state) {
    state.activeEzSignup = initialState.activeEzSignup
  },
  [SIGNUP_RESET_SIGNUP] (state) {
    for (const prop in initialState) {
      state[prop] = initialState[prop]
    }
  },

}
export const getters = {
  signupIsCheckingStatus: state => state.isCheckingStatus,
  signupAccountHolder: state => state.accountHolder,
  signupActiveEzSignup: state => state.activeEzSignup,
  signupActiveEzSignupStatus: state => state.activeEzSignupStatus,
  signupBillingHolder: state => state.billingHolder,
  signupFormStep: state => state.formStep,
  signupLocation: state => state.location,
  signupLocationMarker: state => state.locationMarker,
  signupAvailablePlans: state => state.availablePlans,
  signupSelectedPlan: state => state.selectedPlan,
  signupOptLocationType: state => state.optionsLocationTypes,
  signupOptLocationFloors: state => state.optionsLocationFloors,
  signupOptRoofMaterial: state => state.optionsRoofMaterial,
  signupOptSquareFootage: state => state.optionsSquareFootage,
  signupOptOwnershipStatus: state => state.optionsOwnershipStatus,
  signupOptInstallType: state => state.optionsInstallType,
  signupOptPaymentFreq: state => state.optionsPaymentFrequency,
  signupOptPaymentMethod: state => state.optionsPaymentMethod,
  signupOptEnrollNoWorries: state => state.optionsEnrollNoWorries,
  signupOptAddonBridge: state => state.optionsAddonBridge,
  signupOptNetworkJacks: state => state.optionsNetworkJacks,
  signupOptHeardAboutUs: state => state.optionsHeardAboutUs,
  signupOptPermissionToModify: state => state.optionsPermissionToModify,
  signupOptConfirmMounting: state => state.optionsConfirmMounting,
  signupQuestionnaireValues: state => state.questionnaireValues,
  signupAddonValues: state => state.addonValues,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
